import React, { useEffect, useState } from 'react'
import { addRouting } from './helpers'

import 'leaflet/dist/leaflet.css'
import './style.scss'
import L from 'leaflet'
import 'leaflet.markercluster'
import 'leaflet.markercluster/dist/MarkerCluster.css'
import 'leaflet.markercluster/dist/MarkerCluster.Default.css'
import { fetchResponse } from '../../../controllers/shared/utils/fetch_data'

export default function Routes({ url, graphHopperApiKey, addPoint, height = '35vh', showLinesBetweenRoutes = true }) {
  const [map, setMap] = useState(null)

  useEffect(async () => {
    const newMap = L.map('map')
    setMap(newMap)

    L.tileLayer('https://tiles.stadiamaps.com/tiles/alidade_smooth/{z}/{x}/{y}{r}.png', {
      attribution:
        '&copy; <a href="https://stadiamaps.com/">Stadia Maps</a>, &copy; <a href="https://openmaptiles.org/">OpenMapTiles</a> &copy; <a href="http://openstreetmap.org">OpenStreetMap</a> contributors'
    }).addTo(newMap)

    fetchRoutes({ mapRef: newMap })
  }, [])

  const fetchRoutes = async function ({ mapRef = null }) {
    const response = await fetchResponse(url)

    if (response.ok) {
      const json = await response.json()

      let points = []

      let markers = L.markerClusterGroup()

      json.map(route => {
        points.push(...[route.startingPoint, ...route.stops])
        addRouting({
          color: route.color,
          routeStops: [route.startingPoint, ...route.stops],
          graphHopperApiKey: graphHopperApiKey,
          mapRef: mapRef || map,
          fitBounds: false,
          hideStopPins: addPoint !== undefined,
          markers,
          showLinesBetweenRoutes
        })
      })

      mapRef.addLayer(markers)

      if (addPoint) {
        const stopPin = `
          <span class="fa-stack" style='position: absolute;left: -0.5rem;top: -0.8rem; font-size:15px'>
            <span class="fa-solid fa-location-pin fa-stack-2x" style="color: #5E6FCF"></span>
          </span>
        `
        L.marker(addPoint, { icon: L.divIcon({ html: stopPin }) }).addTo(mapRef)

        mapRef.fitBounds([addPoint])
      } else {
        mapRef.fitBounds(points.map(stop => stop.coordinates))
      }
    }
  }

  return (
    <React.Fragment>
      <div id='map' style={{ height: height, width: '100vw' }} />
    </React.Fragment>
  )
}
